import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables';
import React from 'react';
import styled from 'styled-components';

import {orangeColorRGB, pxToEm} from './globalStyles';

const headerFontSizePx = 44;

const StyledSectionDescription = styled.div`
  color: ${baseVariables.colors.midnight};

  > h1,
  > h2,
  > h3,
  > h4,
  > h5,
  > h6 {
    font-size: ${pxToEm(headerFontSizePx)}em;
    margin-top: ${pxToEm(18) / pxToEm(headerFontSizePx)}em;
    margin-bottom: ${pxToEm(16) / pxToEm(headerFontSizePx)}em;
  }
`;

const StyledTopSubHeadline = styled.p`
  font-size: ${pxToEm(16)}em;
  line-height: 1.6;
  font-weight: bold;
  text-transform: uppercase;
  color: ${orangeColorRGB};
  letter-spacing: 0.18em;
  margin: 0;
`;

const StyledBottomSubHeadline = styled.p<{color: string}>`
  color: ${props => props.color};
  font-size: ${pxToEm(20)}em;
  line-height: 1.6;
  margin: 0;
`;

const Headline = ({headlineType, children}: {headlineType: number; children: string}) => {
  switch (headlineType) {
    case 1:
      return <h1>{children}</h1>;
    case 2:
      return <h2>{children}</h2>;
    case 3:
      return <h3>{children}</h3>;
    case 4:
      return <h4>{children}</h4>;
    case 5:
      return <h5>{children}</h5>;
    case 6:
      return <h6>{children}</h6>;
    default:
      return <h2>{children}</h2>;
  }
};

export interface Props {
  headlineType?: number;
  headline: string;
  topSubHeadline?: string;
  bottomSubHeadline?: string;
  bottomSubHeadlineColor?: string;
  className?: string;
}

const SectionDescription = ({
  headlineType = 2,
  headline,
  topSubHeadline,
  bottomSubHeadline,
  bottomSubHeadlineColor = baseVariables.colors.dusk,
  className
}: Props) => (
  <StyledSectionDescription className={className}>
    {topSubHeadline !== undefined && <StyledTopSubHeadline>{topSubHeadline}</StyledTopSubHeadline>}
    <Headline headlineType={headlineType}>{headline}</Headline>
    {bottomSubHeadline !== undefined && (
      <StyledBottomSubHeadline color={bottomSubHeadlineColor}>{bottomSubHeadline}</StyledBottomSubHeadline>
    )}
  </StyledSectionDescription>
);

export default SectionDescription;
